import { ApiBase } from '@/api/api'
import { makePatchRequest } from '@/api/fetchCalls'
import { MesureResponseModel } from '@/domain/model/measures'

export type UpdateMeasuresQuestionsByFormIdProps = {
  formId: string
  data: Partial<MesureResponseModel['form']>
}

type UpdateMeasuresQuestionResponse = {
  instructions: string
}
export const updateMeasuresQuestionsByFormId = async ({
  formId,
  data,
}: UpdateMeasuresQuestionsByFormIdProps): Promise<UpdateMeasuresQuestionResponse> => {
  return makePatchRequest(ApiBase + `/forms/${formId}/measures`, {
    body: JSON.stringify(data),
  })
}
